import { useState, useRef, useEffect } from "react";

export default function LabelDropdown({
  sublabelTimings,
  filteredSublabelTimings,
  addExtramargins,
  handleCloseLabelSelector,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);

  const filteredOptions = sublabelTimings.filter(
    (sibling) =>
      filteredSublabelTimings.some((s) => s.subname === sibling.subname) &&
      sibling.subname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (selectedLabel) => {
    const index = sublabelTimings.findIndex(
      (sibling) => sibling.subname === selectedLabel
    );
    addExtramargins(index);
    handleCloseLabelSelector();
    setShowDropdown(false);
    setSearchTerm(""); // reset input
  };

  const handleInputClick = () => {
    setShowDropdown(true);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={wrapperRef} className="relative dropdown-container">
      <input
        type="text"
        placeholder="Select or search label..."
        className="w-full p-2 border border-gray-300 rounded cursor-pointer dropdown-input"
        style={{ marginTop: "10px", marginBottom: "5px" }}
        value={searchTerm}
        onClick={handleInputClick}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setShowDropdown(true);
        }}
      />

      {showDropdown && (
        <div className="z-10 w-full bg-white border border-gray-300 rounded max-h-40 overflow-y-auto shadow-md drop-down-menu">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((sibling, index) => (
              <div
                key={`label_option_${index}`}
                className="px-2 py-1 cursor-pointer dropdown-option"
                onClick={() => handleSelect(sibling.subname)}
              >
                {sibling.subname}
              </div>
            ))
          ) : (
            <div className="px-2 py-1 text-gray-400">No labels found</div>
          )}
        </div>
      )}
    </div>
  );
}
